'use client';

import { cn } from '@shared/components/shadcn';
import { useClientConfig } from '@shared/utils';

/**
 * DevEnvironmentInfo component displays branch name and commit SHA in bottom center of the screen.
 * Only visible in non-production environments.
 */
function DevEnvironmentInfo() {
  const config = useClientConfig();

  // Only show in non-production environments
  if (config.isProduction) {
    return null;
  }

  // Don't show if both branch and commitSha are empty
  if (!config.branch && !config.commitSha) {
    return null;
  }

  return (
    <div
      className={cn(
        'fixed bottom-4 left-1/2 -translate-x-1/2 z-50',
        'border border-container rounded-lg px-3 py-2',
        'text-xs font-mono text-foreground-secondary',
        'shadow-lg backdrop-blur-sm bg-background/90',
        'select-none pointer-events-none'
      )}
      data-testid="dev-environment-info"
    >
      <div className="flex flex-col gap-1">
        {config.branch && (
          <div className="flex items-center gap-2">
            <span className="text-foreground-tertiary">branch:</span>
            <span className="font-semibold" data-testid="dev-branch">
              {config.branch}
            </span>
          </div>
        )}
        {config.commitSha && (
          <div className="flex items-center gap-2">
            <span className="text-foreground-tertiary">commit:</span>
            <span className="font-semibold" data-testid="dev-commit-sha">
              {config.commitSha}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export { DevEnvironmentInfo };
